// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-tab-button {
  position: relative;
}
ion-tab-button ion-icon {
  fill: var(--ion-color-secondary);
}
ion-tab-button.tab-selected ion-icon {
  fill: var(--ion-color-primary) !important;
}

ion-tab-bar {
  --background: white;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.1490196078);
}

ion-label {
  margin-top: 10px;
  font-family: AppFont, sans-serif;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: var(--ion-color-secondary);
}

.selected ion-icon {
  fill: var(--ion-color-primary) !important;
}
.selected ion-label {
  color: var(--ion-color-primary);
}

.order-index {
  position: absolute;
  background: var(--ion-color-primary);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  right: 15px;
  top: 1px;
  z-index: 99;
  transition: all 0.3s linear;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-index p {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  color: white;
}

.hidden {
  opacity: 0;
  height: 0;
  transition: all 0.3s linear;
}

.splash {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
}

.splash {
  width: 100%;
  height: 100%;
}
.splash ion-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.fullscreen-bg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: -100;
  position: absolute;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AADJ;AAEI;EACI,gCAAA;AAAR;AAGQ;EACI,yCAAA;AADZ;;AAMA;EACI,mBAAA;EACA,4DAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,iCAAA;AAJJ;;AAOI;EACI,yCAAA;AAJR;AAMI;EACI,+BAAA;AAJR;;AAOA;EACI,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,WAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAMI;EACI,oCAAA;EACA,eAAA;EACA,YAAA;AAJR;;AAUA;EACI,UAAA;EACA,SAAA;EACA,2BAAA;AAPJ;;AASA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AANJ;;AASA;EACI,WAAA;EACA,YAAA;AANJ;AAOI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AALR;;AASA;EACI,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AANJ","sourcesContent":["\n// @import \"~animate.css\";\nion-tab-button {\n    position: relative;\n    ion-icon {\n        fill: var(--ion-color-secondary);\n    }\n    &.tab-selected {\n        ion-icon {\n            fill: var(--ion-color-primary) !important;\n        }\n    }\n}\n\nion-tab-bar {\n    --background: white;\n    box-shadow: 0px -4px 15px 0px #4F614F26;\n}\n\nion-label {\n    margin-top: 10px;\n    font-family: AppFont, sans-serif;\n    font-size: 14px;\n    line-height: 18px;\n\n    text-align: center;\n    color: var(--ion-color-secondary);\n}\n.selected {\n    ion-icon {\n        fill: var(--ion-color-primary) !important;\n    }\n    ion-label {\n        color: var(--ion-color-primary);\n    }\n}\n.order-index {\n    position: absolute;\n    background: var(--ion-color-primary);\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n\n    right: 15px;\n    top: 1px;\n    z-index: 99;\n    transition: all 0.3s linear;\n    opacity: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    p  {\n        font-family: AppFontBold,sans-serif;\n        font-size: 12px;\n        color: white;\n\n    }\n\n}\n\n.hidden {\n    opacity: 0;\n    height: 0;\n    transition: all 0.3s linear;\n}\n.splash {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 999;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: black;\n}\n\n.splash {\n    width: 100%;\n    height: 100%;\n    ion-img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 90%;\n    }\n}\n\n.fullscreen-bg {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: hidden;\n    z-index: -100;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n}\nion-tabs {\n    // box-shadow: 0px -4px 15px 0px #4F614F26;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
